<template>
    <!--拉幕广告-->
    <div class="pw" id="adv" v-show="ifShow">
        <div ref="ad" class="lamu">
            
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import {
    sendScData
} from "@/utils/buriedPoint";
export default {
    name: "advLamu",
    props:['advCode','isDD','ddCode','sendSc','current_page', 'banner_belong_area', 'banner_name','cur_page','cur_moudle','cur_button'],
    data(){
        return{
            ifShow:false
        }
    },
    mounted() {
        let el = this.$refs['ad']
        this.renderAD(el)
    },
    methods:{
        renderAD(el) {
            let that = this
            fetch('https://show.artron.net/g?english='+this.advCode).then(r => r.text()).then(res => {
                if(res != ''){
                    this.ifShow = true
                }
                let document = {
                    write: text => {
                        el.innerHTML += text
                        this.ifShow = text!=''?true:false
                    }
                }
                eval(res)
                this.closeLamu()
                this.switchAdv(el)
            })
        },
        switchAdv(el){
            let that = this;
            $(function (){
                let me = $(el)
                let length = me.find('.artronAdvLink').length,
                    index=0,
                    onceTime = me.find('.abc').data("once") || 3500;
                me.find('.artronAdvLink').attr('target','_blank')
                if(length <= 1){
                    return;
                }
                var toggleInterval = setInterval(function () {
                    index++;
                    me.find(".artronAdvLink:eq(" + index + ")").show().siblings(".artronAdvLink").hide();
                }, onceTime);
                sendScData('bannerExpose', {
                            // cur_page: that.cur_page,
                            // cur_moudle: that.cur_moudle,
                            // cur_button: that.cur_button,
                            cur_page:that.current_page,
                            banner_type_id: '',
                            banner_order_id: '',
                            banner_advertiser_id:  '',
                            remarks:  '',
                            banner_link_type: '',
                            banner_link: '',
                            banner_englishName: that.ddCode || '',
                });
            })
        },
        closeLamu(){
            let that = this;
            $(function (){
                if (that.sendSc) {
                    $(".lamu a").on("click", function () {
                        sendScData('allClick', {
                            cur_page:that.current_page,
                            banner_type_id: '',
                            banner_order_id: '',
                            banner_advertiser_id:  '',
                            remarks:  '',
                            banner_link_type: '',
                            banner_link: '',
                            banner_englishName: that.ddCode || '',
                        });
                    })
                }
                var bigBgTimeout = setTimeout(function(){
                    clearTimeout(bigBgTimeout)
                    $(".lamu_close").trigger("click");
                },7000);
                $(".lamu_close").hover(function(){
                    $(this).children("img").attr("src","https://pubunder.artron.net/pubimgs/web/lamu_close2.gif")
                },function(){
                    $(this).children("img").attr("src","https://pubunder.artron.net/pubimgs/web/lamu_close1.gif")
                }).one("click",function(){
                    clearTimeout(bigBgTimeout);
                    $("#adv .lamu").animate({
                        "height" : "0px"
                    },500,"linear",function(){
                        $('#adv').remove();
                    });
                });
           
           


            })
        }
    }
}
</script>

<style scoped lang="scss">
</style>